import { RuoloUtente } from '../../+configurazione/ruoloutente/ruoloutente.model';
import { Utente } from '../../+configurazione/utente/utente.model';
import { Ruolo } from '../../+configurazione/ruolo/ruolo.model';
import { EntitaOrganizzativa } from '../entitaorganizzativa/entitaorganizzativa.model';

export class Delega extends RuoloUtente {

  constructor(protected id: number,
              public utente: Utente,
              public ruolo: Ruolo,
              public entitaOrganizzativa: EntitaOrganizzativa,
              public note: string,
              public provvedimento: string,
              public attivo: boolean,
              public delega: boolean,
              public inizioValidita: string,
              public fineValidita: string,
              public indennita: boolean,
              public importoIndennita: number,
              public soal: boolean,
              public ruoloUtenteDelegante: number,
              public ruoloEntitaOrganizzativaDelegante: number
  ) {
    super(id, utente, ruolo, entitaOrganizzativa, note, provvedimento, attivo, delega, inizioValidita, fineValidita, indennita, importoIndennita, soal);
  }

  // public static getTableKeys() {
  //   return ['persona', 'entitaorganizzativa', 'ruolo', 'Inizio', 'Fine'];
  // }
  //
  // public toTableRow(): TableRow {
  //   const rowValues = new Map();
  //   rowValues.set('persona', new TableRowValue(this.persona.getLabel(), null));
  //   rowValues.set('entitaorganizzativa', new TableRowValue(this.entitaOrganizzativa ? this.entitaOrganizzativa.getSigla() : null, null));
  //   rowValues.set('ruolo', new TableRowValue(this.ruolo.getLabel(), null));
  //   rowValues.set('Inizio', new TableRowValue(Helpers.formatDateView(this.getInizio()), null));
  //   rowValues.set('Fine', new TableRowValue(Helpers.formatDateView(this.getFine()), null));
  //   return new TableRow(this, rowValues);
  // }
  //
  // public getLabel() {
  //   let label = 'Assegnazione ' + this.ruolo.getLabel() + ' - ' + this.persona.getLabel();
  //   if (this.entitaOrganizzativa) {
  //     label = label + ' - ' + this.entitaOrganizzativa.getLabel();
  //   }
  //   return label;
  // }

}

